import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NonogramTopTimes } from '@games/api';
import messages from 'intl/messages';
import TopTimeRow from './TopTimeRow';

const TopTimeList: React.FC<NonogramTopTimes> = ({ size, times }) => (
  <div className='w-full'>
    <table className='w-full text-left'>
      <tr>
        <td colSpan={3} className='text-center text-xl font-bold'>
          <FormattedMessage {...messages.topTimesFor} values={{ size }} />
        </td>
      </tr>
      {times.length === 0 ? (
        <tr>
          <td colSpan={3}>
            <FormattedMessage {...messages.noTimes} />
          </td>
        </tr>
      ) : (
        <tr className='border-b-2 border-gray-300'>
          <td className='w-1/2'>
            <b>
              <FormattedMessage {...messages.user} />
            </b>
          </td>
          <td className='text-right'>
            <b>
              <FormattedMessage {...messages.time} />
            </b>
          </td>
          <td className='text-right'>
            <b>
              <FormattedMessage {...messages.puzzle} />
            </b>
          </td>
        </tr>
      )}
      {times.map(time => (
        <TopTimeRow {...time} key={JSON.stringify(time)} />
      ))}
    </table>
  </div>
);

export default TopTimeList;
